import React from 'react';
import { Accordion } from "../common/accordion";
import { handleStatQuestionCarrotClick } from '../common/statistics';

const listExample = [
  {
    id: 1,
    title: 'What is a High Yield Savings account?',
    description: (
      <p>
        A high-yield savings account is a savings account that offers a higher interest rate than a
        { ' ' }
        regular savings account. The interest earned is calculated as an annual
        { ' ' }
        percentage yield (APY).
      </p>
    )
  },
  {
    id: 2,
    title: 'What is Openbank?',
    description: (
      <p>
        Openbank is a division of Santander Bank, N.A., one of the nation's largest banks by assets.
        { ' ' }
        Openbank combines the best of digital banking innovation with the stability and security
        { ' ' }
        of a large national bank to deliver a seamless and powerful digital banking experience.
      </p>
    )
  },
  {
    id: 3,
    title: 'What are the benefits of opening an account through Verizon + Openbank Savings?',
    description: (
      <p>
        When you open a high-yield savings account through Verizon + Openbank Savings, you're
        { ' ' }
        getting a top-tier rate and an FDIC insured savings account. Plus, you may receive exclusive
        { ' ' }
        Verizon Bill Credit(s) on your monthly Verizon mobile bill. The Verizon Bill Credit
        { ' ' }
        stacks on top of what you may earn today with Verizon’s Auto Pay discounts.
      </p>
    )
  },
  {
    id: 4,
    title: 'How do I apply for a high-yield savings account with Openbank?',
    description: (
      <p>
        You can open an account by first visiting the
        { ' ' }
        <span className="pseudo-link">Verizon + Openbank Savings page.</span>
        { ' ' }
        Click the "Get Started" button above to log in and verify that you are a Verizon mobile
        { ' ' }
        customer first. Then follow the instructions provided to complete your application.
      </p>
    )
  },
  {
    id: 5,
    title: 'What do I need to apply for a high-yield savings account through Verizon + Openbank Savings?',
    description: (
      <>
        <p>
          You'll need an existing Verizon mobile account with up to 12 phone lines maximum
          { ' ' }
          (depending on your plan), 5G Home Internet or LTE Home Internet to be eligible to apply
          { ' ' }
          for the Verizon + Openbank Savings account. Verizon Prepaid, Verizon mobile Business,
          { ' ' }
          Verizon Fios and Verizon Fios Business accounts are not eligible for
          { ' ' }
          Verizon + Openbank Savings.
        </p>
        <p>
          You'll also need to be at least 18 years old, a U.S. Citizen or U.S. Resident Alien with a
          { ' ' }
          U.S. residential address and mobile phone number, and have a mobile phone or tablet on
          { ' ' }
          which you can install the Openbank app.
        </p>
      </>
    )
  },
  {
    id: 6,
    title: 'What is the Verizon Bill Credit(s)? Is there a minimum balance requirement? What happens if I go below the minimum balance?',
    description: (
      <>
        <p>
          Yes, there is a minimum balance requirement of $500 to open a high-yield savings account
          { ' ' }
          with Openbank. In order to receive the monthly Verizon Bill Credit, you will need a
          { ' ' }
          monthly average daily minimum balance of $1,000 in your account. If your monthly average
          { ' ' }
          daily balance falls below this amount you will not be eligible for the Verizon
          { ' ' }
          Bill Credit.
        </p>
        <p>
          The Verizon Bill Credit is based on the monthly average daily balance of your High Yield
          { ' ' }
          Savings account and can range between $5, $10 or $15 a month according to the following:
        </p>
        <ul>
          <li>
            Get up to $60/year ($5/month) in Verizon Bill Credits if your average account balance
            { ' ' }
            is between $1,000 and $9,999.99. Offer valid for up to 12 consecutive months
            { ' ' }
            from the date you open the account.
          </li>
          <li>
            Get up to $120/year ($10/month) in Verizon Bill Credits if your average account balance
            { ' ' }
            is between $10,000 and $29,999.99. Offer valid for up to 12 consecutive months from
            { ' ' }
            the date you open the account.
          </li>
          <li>
            Get up to $180/year ($15/month) in Verizon Bill Credits if your balance is $30,000 or
            { ' ' }
            more. Offer valid for up to 12 consecutive months from the date you open the account.
          </li>
        </ul>
      </>
    )
  },
  {
    id: 7,
    title: 'How do I manage my account with Openbank? (Is there an app?)',
    description: (
      <p>
        Openbank is a fully digital bank, which means that all account management – including
        { ' ' }
        tracking your balance, transferring funds, and viewing account activity – happens
        { ' ' }
        exclusively on the Openbank app or online at
        { ' ' }
        <span className="pseudo-link">www.openbank.us</span>.
      </p>
    )
  },
  {
    id: 8,
    title: 'Can I access Verizon + Openbank Savings at ATMs and make withdrawals?',
    description: (
      <p>
        No, not at this time. High-yield savings accounts at Openbank do not currently offer debit
        { ' ' }
        cards. In order to make withdrawals, you’ll need to link your account at Openbank to an
        { ' ' }
        account at another institution (to set this up, you'll need the account number and
        { ' ' }
        routing number for your other bank account).
      </p>
    )
  }
];

const Questions = () => {
  return (
    <div className="questions">
      <div className="container">
        <div className="questions-wrapper">
          <div className="section-header">
            <h2 className="section-header">Have questions?<br />We’ve got answers.</h2>
          </div>

          <Accordion openAll list={ listExample } onClick={ handleStatQuestionCarrotClick } />
        </div>
      </div>
    </div>
  );
};

export default Questions;
